import React from 'react'
import { NavLink } from 'react-router-dom'


const TableProjects = props => {
    const { projects, onclickDownload, wasFormSubmited } = props

    function onSelectedAllProjects(e) {
        var checkBoxes = document.getElementsByClassName('checkbox')
        var isChecked = e.checked
        Array.prototype.forEach.call(checkBoxes, function (item) {
            item.checked = isChecked;
        });
    }

    if (projects.length === 0)
        if (wasFormSubmited)
            return <p className='has-text-centered'>No se encontraron resultados</p>
        else
            return <div></div>
    return (
        <table className='table is-bordered is-fullwidth is-acervo'>
            <thead>
                <tr>
                    <th>
                        <label className="checkbox-green">
                            <input
                                type="checkbox"
                                onChange={e => onSelectedAllProjects(e.target)}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </th>
                    <th>año</th>
                    <th>modalidad</th>
                    <th>estado</th>
                    <th>municipio</th>
                    <th>folio</th>
                    <th>proyecto</th>
                    <th>acciones</th>
                </tr>
            </thead>
            <tbody>
                {
                    projects.map(project =>
                        <tr key={project.project_id}>
                            <td>
                                <label className="checkbox-green">
                                    <input
                                        className='checkbox'
                                        type="checkbox"
                                        value={project.project_id}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                            </td>
                            <td>{project.year}</td>
                            <td>{project.modality_name}</td>
                            <td>{project.state_name}</td>
                            <td>{project.municipality_name}</td>
                            <td>{project.project_code}</td>
                            <td>{project.project_name}</td>
                            <td className='has-text-centered'>
                                <div style={{ 'display': 'flex-inline' }}>
                                    <NavLink to={`/acervo/proyectos/${project.project_id}`} className={`button is-rounded is-small`}>
                                        <span className="icon is-small"><i className='fa fa-info'></i></span>
                                    </NavLink>
                                    <a
                                        className="button is-rounded is-small"
                                        onClick={e => onclickDownload(project.project_id, '')}
                                    >
                                        <span className="icon is-small"><i className='fa fa-download'></i></span>
                                    </a>
                                    <a
                                        className="button is-rounded is-small"
                                        onClick={e => onclickDownload(project.project_id, 'detail')}
                                    >
                                        <span className="icon is-small"><i className='fa fa-file-archive-o'></i></span>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}

export default TableProjects


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Home/TableProjects.js